'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = init;

var _swiperEsm = require('swiper/js/swiper.esm.js');

var _helpers = require('./_helpers');

function init(_ref) {
  var el = _ref.el,
      context = _ref.context;

  var swiperContainer = context.getElement('.' + context.className + '_Carousel');

  makeCarousel();

  function makeCarousel() {
    (0, _helpers.initialiseSwiper)(swiperContainer, {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: 1.4,
      slidesOffsetBefore: -15,
      centeredSlides: true,
      initialSlide: 1,
      spaceBetween: 15,
      speed: 500,
      slideClass: context.className + '_Slide',
      breakpoints: {
        768: {
          slidesPerView: 2.9,
          slidesOffsetBefore: 115
        }
      },
      navigation: {
        nextEl: '.' + context.className + '_Next',
        prevEl: '.' + context.className + '_Prev'
      }
    }, [_swiperEsm.Navigation]);
  }
}